import React from "react";
import Slider from "react-slick";

const partners = [
  // { id: 1, logo: "/images/plogo/Plogo-37.png" },
  { id: 2, logo: "/images/plogo/diamond_logo2.png" },
  { id: 3, logo: "/images/plogo/bb.png" },
  { id: 4, logo: "/images/plogo/fmgolf.png" },
  { id: 5, logo: "/images/plogo/littlevietnam.jpg" },
  { id: 6, logo: "/images/plogo/sjnail.jpg" },
];

const Partners = () => {
  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Slider {...settings}>
      {partners.map((partner) => (
        <div key={partner.id} className="flex justify-center items-center">
          <div className="w-32 h-16 flex items-center justify-center">
            <img
              src={partner.logo}
              alt="Partner logo"
              className="h-full object-contain grayscale opacity-80"
            />
          </div>
        </div>
      ))}
    </Slider>
  );
};

export default Partners;
